import { browser } from '$app/environment';
import { locale, waitLocale, init } from 'svelte-i18n';
import type { LayoutLoad } from './$types';
import { defaultLocale } from '$lib/i18n'; // Import to register locales

export const prerender = true;

export const load: LayoutLoad = async ({ data }) => {
	// Get the locale from server data or fallback
	const serverLocale = data?.locale || 'en';
	
	// On client side, check for user preference
	let targetLocale = serverLocale;
	if (browser) {
		const savedLocale = localStorage.getItem('locale');
		if (savedLocale) {
			targetLocale = savedLocale;
		} else {
			// Save the server-detected locale for consistency
			localStorage.setItem('locale', serverLocale);
		}
	}
	
	// Set the locale
	locale.set(targetLocale);
	
	// Wait for locale to be loaded - this ensures translations are available
	await waitLocale(targetLocale);
	
	return {
		locale: targetLocale
	};
};